import { Map } from 'immutable';
import AutoComplete from 'portaltransparencia-common/components/AutoComplete.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import {
  onChange,
  resetCrud
} from 'portaltransparencia-common/crud/Actions.js';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

import * as actions from '../Actions.js';

export class CargosFiltroOxy extends Component {
  static propTypes = {
    location: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    resetCrud: PropTypes.func.isRequired,
    errors: PropTypes.object,
    filtros: PropTypes.object,

    filtro: PropTypes.string,
    loadCargosComNiveis: PropTypes.func.isRequired,
    findCargosSelect: PropTypes.func.isRequired,
    findPlanosSalariais: PropTypes.func.isRequired
  };

  onPesquisa = event => {
    const { filtro, loadCargosComNiveis } = this.props;

    loadCargosComNiveis(filtro);

    event && event.preventDefault();
    this.refs.panelFiltroCargos && this.refs.panelFiltroCargos.collapse();
  };

  onChangeFiltro = event => {
    const { onChange } = this.props;

    new Promise(resolve => {
      onChange('filtroCargos', event);
      resolve();
    }).then(() => {
      switch (event.name) {
        case 'cargo': {
          this.findCargos();
          break;
        }

        case 'planoSalarial': {
          this.findPlanoSalarial();
          break;
        }
      }
    });
  };

  onResetFiltro = () => {
    const { resetCrud, loadCargosComNiveis } = this.props;

    resetCrud('filtroCargos');
    loadCargosComNiveis('');
  };

  findCargos = () => {
    const { findCargosSelect, filtro } = this.props;

    return findCargosSelect(filtro);
  };

  findPlanoSalarial = () => {
    const { findPlanosSalariais, filtro } = this.props;

    return findPlanosSalariais(filtro);
  };

  renderValue = option => {
    return <span>{option.descricao}</span>;
  };

  render() {
    const { filtros, errors } = this.props;

    return (
      <form>
        <div className="panel-inside-panel mt-xs">
          <Panel
            title="Consultar Cargos"
            isForm
            tableResponsive
            ref="panelFiltroCargos"
          >
            <Row>
              <Col xs={12} sm={4} md={6} key={filtros.get('cargo')}>
                <AutoComplete
                  label="Cargo"
                  id="cargo"
                  name="cargo"
                  onLoad={this.findCargos}
                  onChange={this.onChangeFiltro}
                  value={filtros.get('cargo')}
                  errors={errors}
                  valueKey="codigo"
                  labelKey="descricao"
                  placeholder="Selecione o Cargo"
                  clearable
                  optionRenderer={this.renderValue}
                />
              </Col>

              <Col xs={12} sm={4} md={3}>
                <div className="form-group">
                  <label className="label"></label>
                  <div className="btn-group">
                    <button
                      id="btnFiltrar"
                      className="btn module-color icon-right inline"
                      ref="pesquisar"
                      onClick={this.onPesquisa}
                    >
                      Pesquisar
                      <em className="fa fa-search"></em>
                    </button>
                    <button
                      id="btnReset"
                      className="btn neutral icon-right inline no-text"
                      type="button"
                      ref="limpar"
                      onClick={this.onResetFiltro}
                    >
                      Limpar
                      <em className="fa fa-times"></em>
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          </Panel>
        </div>
      </form>
    );
  }
}
function mapStateToProps(state) {
  return {
    filtros: state.crud.getIn(['filtroCargos', 'currentRecord'], Map({}))
  };
}
const allActions = {
  ...actions,
  onChange,
  resetCrud
};
export default connect(mapStateToProps, allActions)(CargosFiltroOxy);
